
          var jq = window.jQuery || window.$;
          if (!jq) {
            throw new Error("jQuery not found on window. Enqueue WP's jquery before theme bundle.");
          }

          // CommonJS export (important for Slick/UMD require("jquery"))
          module.exports = jq;

          // Extra interop so both require() and import work smoothly
          module.exports.default = jq;
          module.exports.jQuery = jq;
          module.exports.$ = jq;
        